<template>
  <div class="YJ_registry-wrap">
    <div id="registry">
      <div class="registry-log" v-if="showLog">
        <img src="../../assets/images/cur-banner.png" alt="合作伙伴" />
      </div>
      <div class="registry-content">
        <div class="form-title">填写以下信息，立即预约</div>
        <div class="form-content">
          <a-form
            ref="formRef"
            autocomplete="off"
            :scrollToFirstError="true"
            :model="formState"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
            @finish="validateSuccess"
            @finishFailed="validateFail"
          >
            <a-form-item
              label="如何称呼您"
              name="appellation"
              :rules="[{ required: false }]"
            >
              <a-input
                placeholder="请输入称呼"
                v-model:value="formState.appellation"
              />
            </a-form-item>
            <a-form-item
              label="所在地区"
              name="area"
              :rules="[{ required: true, message: '请选择所在地区' }]"
            >
              <a-cascader
                :options="options"
                placeholder="请选择所在地区"
                v-model:value="formState.area"
              />
            </a-form-item>
            <a-form-item
              label="手机号"
              name="telephoneNumber"
              :rules="[{ required: true, message: '请输入手机号' }]"
            >
              <div class="telephoneView">
                <a-input
                  placeholder="请输入手机号"
                  v-model:value="formState.telephoneNumber"
                  :maxLength="11"
                  @change="formatPhone"
                />
              </div>
            </a-form-item>
            <a-form-item
              label="验证码"
              name="registryCode"
              :rules="[{ required: true, message: '请输入验证码' }]"
            >
              <a-input
                placeholder="请输入验证码"
                v-model:value="formState.registryCode"
                :maxlength="6"
              />
              <a-button
                type="link"
                class="btn-getcode"
                @click="getRegistryCode"
              >
                {{ btnText }}
              </a-button>
            </a-form-item>
            <div id="captcha-element"></div>
            <button id="captcha-button" style="display: none"></button>
            <a-form-item
              name="agreed"
              :rules="[{ required: true, message: '请先同意隐私协议' }]"
              :wrapper-col="{ span: 24 }"
              style="border: none"
            >
              <a-checkbox v-model:checked="formState.agreed">
                我已阅读并同意
                <a href="https://www.linkedsmile.com/#/privacy" target="_blank"
                  >《隐私协议》</a
                >
              </a-checkbox>
            </a-form-item>
            <a-form-item
              :wrapper-col="{ span: 14, offset: 4 }"
              style="border: none"
            >
              <a-button
                class="btn-registry"
                type="primary"
                html-type="submit"
                :loading="loading"
                >立即申请</a-button
              >
            </a-form-item>
          </a-form>
        </div>
        <div class="form-consult">
          <img class="qrcode" src="../../assets/images/QR.png" alt="咨询" />
          <div class="form-notice">如果注册失败，您可以扫描添加顾问</div>
        </div>
      </div>
    </div>
    <div class="error-wrap" v-if="showSuccess">
      <img src="../../assets/images/Icon-warning.png" alt="warning" />
      <p class="title">感谢您的申请</p>
      <div class="errormsg">
        <p>感谢您对 悦见LinkedSmile 的支持！</p>
        <p>我们已经收到您的注册请求，请您耐心等待，</p>
        <p>我们将在 <span class="timeNotice">2个工作日</span> 内与您联系。</p>
      </div>
      <!-- <a-button class="to-LShome" @click="toHomePage">返回首页</a-button> -->
      <a-button
        class="to-LShome"
        @click="
          () => {
            showSuccess = false
          }
        "
        >好的</a-button
      >
      <div
        class="close"
        @click="
          () => {
            showSuccess = false
          }
        "
      ></div>
    </div>
    <div class="error-wrap" v-if="showError">
      <img src="../../assets/images/Icon-warning.png" alt="warning" />
      <p class="title">申请失败</p>
      <div class="errormsg">{{ errorMsg }}</div>
      <img class="qrcode" src="../../assets/images/QR.png" alt="warning" />
      <p class="subtitle">如遇注册失败，您可以扫码添加顾问</p>
      <div class="close" @click="closeError"></div>
    </div>
  </div>
</template>
<script>
import { message } from 'ant-design-vue'
import location from '../../data/location'
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  onUnmounted,
  computed
} from 'vue'
import { get, post } from '../../service/http'
import QS from 'qs'
import '../doctorRegister/index.less'

export default defineComponent({
  name: 'DoctorRegistry',
  components: {},
  setup() {
    let isRegistry = ref(true) // 补充信息展示标志位
    let btnText = ref('获取短信验证码') // countdown 按钮文本
    let options = ref(location) // 地区信息
    let showLog = ref(true) // 是否展示左半部分
    let showError = ref(false) // 是否展示错误弹窗
    let errorMsg = ref('') // 错误信息
    let interval = '' // 计时器
    let time = 60 // 倒计时
    let token = '' // token
    let parentUrl = '' // 父窗口url
    let loading = ref(false)
    const formRef = ref()
    let showSuccess = ref(false) //是否展示正确弹窗

    const formState = reactive({
      telephoneNumber: '',
      registryCode: '',
      organization: '',
      area: '',
      appellation: '',
      agreed: false
    })
    const mobileReg = /^1\d{10}$/
    const ua = navigator.userAgent
    const ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
      isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
      isAndroid = ua.match(/(Android)\s+([\d.]+)/),
      isMobile = isIphone || isAndroid

    onMounted(() => {
      // 接收parent消息
      window.addEventListener(
        'message',
        function (event) {
          const parentData = event.data
          parentUrl = parentData.url || ''
        },
        false
      )
      if (isMobile) {
        showLog.value = false
      } else {
        showLog.value = true
      }

      // 倒计时
      time = +localStorage.getItem('leftTime') || 60
      // 如果没有倒计时结束 则继续倒计时
      if (time > 0 && time < 60) {
        countDown()
      }

      // 获取token
      getToken()

      // 初始化滑块
      slideInit()
    })

    onUnmounted(() => {
      document.body.style.backgroundColor = '#fff'
    })

    // 初始化验证码2.0
    const slideInit = function () {
      window.initAliyunCaptcha({
        // 替换为验证码2.0控制台 -> 场景管理 -> 场景ID
        SceneId: 'ud7lurc8',
        mode: 'popup',
        element: '#captcha-element',
        button: '#captcha-button',
        slideStyle: { width: 320, height: 40 },
        success: function (captchaVerifyParam) {
          getSMS(captchaVerifyParam)
        },
        fail: function (result) {
          console.error(result)
        },
        onError: function (error) {
          console.error(error)
        }
      })
    }

    const validateSuccess = (values) => {
      // eslint-disable-next-line no-debugger
      if (!formState.agreed) {
        message.warning('请先同意隐私协议')
        return
      }
      if (isRegistry.value) {
        loading.value = true
        const url = parentUrl || getParentUrl()
        const queries = parseUrl(url)
        const requestBody = {
          SourceCode: queries.source || '', // 线索来源
          SourceDetail1: queries.e_keywordid ? '付费推广' : '自然流量', // 细分来源
          ContactName: values.appellation, // 客户联系人
          CustomerName: values.organization ? values.organization : '', // 诊所/机构名称
          MobilePhone: values.telephoneNumber.replace(/\s+/g, ''), // 联系人手机号
          Province: values.area[0], // 省，例如北京市
          City: values.area[1], // 城，例如北京市
          authCode: values.registryCode, // 验证码
          KeyWord: queries.e_keywordid, //百度搜素关键字id
          EntityType: '3095150', // 业务类型编码 口腔：3095150，医美：5067108，其他：3095150
          ClientType: isMobile ? '手机' : '电脑',
          clientIP: '', // 前端无法精确拿到客户端ip地址x
          FirstConsultType: 'gt2TaY1Mf', //咨询需求一级分类 : gt2TaY1Mf--正畸
          SecondConsultType: 'JgrNu11Rf' //咨询需求二级分类:2Cb6X08ca--医生   JgrNu11Rf--消费者 consumers
        }
        post('/Leads', requestBody, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
          .then(function (response) {
            console.log(response)
            loading.value = false
            if (response.result.success) {
              showSuccess.value = true
              formRef.value.resetFields()
            } else {
              if (isMobile) {
                message.error(response.result.message)
              } else {
                errorMsg.value = response.result.message
                showError.value = true
              }
            }
          })
          .catch(function (error) {})
      } else {
        isRegistry.value = true
      }
    }

    const validateFail = (errorInfo) => {
      if (!isRegistry.value) {
        isRegistry.value = true
      }
      console.log('Failed:', errorInfo)
    }
    // 获取token
    const getToken = function () {
      get('/token?account=marketregister&password=register@123')
        .then(function (res) {
          token = res.result.token
        })
        .catch(function (error) {
          console.log(error)
        })
    }
    // 获取查询对象
    const parseUrl = function (url) {
      url = url || window.location.href
      const startPoint = url.indexOf('?') + 1
      const endPoint = url.length
      const urlSegment = url.slice(startPoint, endPoint)
      const kvArr = urlSegment.split('&')
      return kvArr.reduce(function (prev, curr) {
        const kv = curr.split('=')
        prev[kv[0]] = kv[1]
        return prev
      }, {})
    }
    // 获取父页面url
    const getParentUrl = function () {
      let url = ''
      try {
        url = window.top.document.referrer
      } catch (M) {
        if (window.parent) {
          try {
            url = window.parent.document.referrer
          } catch (L) {
            url = ''
          }
        }
      }
      if (url === '') {
        url = document.referrer
      }
      return url
    }
    // 点击获取验证码handle
    const getRegistryCode = function () {
      let { telephoneNumber } = formState
      telephoneNumber = telephoneNumber.replace(/\s+/g, '')
      if (time === 60) {
        if (mobileReg.test(telephoneNumber)) {
          // 触发验证码弹窗
          document.getElementById('captcha-button').click()
        } else {
          message.error('请输入正确的手机号')
        }
      }
    }
    // 获取短信验证码
    const getSMS = function (captchaVerifyParam) {
      post(
        'shortmessage/sendmsg',
        QS.stringify({
          captchaVerifyParam,
          contentHeader: '【悦见】',
          phoneNumber: formState.telephoneNumber.replace(/\s+/g, '')
        })
      )
        .then(function (response) {
          if (response.result.success) {
            message.success('发送成功')
            isRegistry.value = true
            countDown()
          } else {
            message.error(response.result.message)
          }
        })
        .catch(function (error) {})
    }
    // 倒计时
    const countDown = function () {
      interval = setInterval(() => {
        if (time > 0) {
          time--
          btnText.value = `${time}s`
          localStorage.setItem('leftTime', time)
        } else {
          time = 60
          clearInterval(interval)
          btnText.value = '重新获取'
          localStorage.removeItem('leftTime')
        }
      }, 1000)
    }

    // 关闭错误弹窗
    const closeError = function () {
      showError.value = false
    }

    const formatPhone = (e) => {
      let val = e.target.value
      val = mobileReg.test(formState.telephoneNumber)
        ? val.replace(/(^\d{3}|\d{4}\B)/g, '$1 ')
        : val.replace(/\s+/g, '')
      formState.telephoneNumber = val
    }
    const toHomePage = () => {
      window.location.href = 'https://yuejian.linkedcare.cn/'
    }

    return {
      validateSuccess,
      validateFail,
      getRegistryCode,
      closeError,
      formatPhone,
      formState,
      isRegistry,
      btnText,
      options,
      showLog,
      showError,
      errorMsg,
      loading,
      showSuccess,
      formRef,
      toHomePage
    }
  }
})
</script>
